import React from "react";
import { cn } from "@/lib/utils";
import { motion, AnimatePresence } from "framer-motion";

interface BottomActionBarProps {
  children: React.ReactNode;
  className?: string;
  visible?: boolean;
}

/**
 * 通用底部动作栏 (Generic Bottom Action Bar)
 * 统一管理底部固定按钮的布局、背景渐变和适配
 * Used for: History Button, Smart CTA Bar, etc.
 */
export const BottomActionBar: React.FC<BottomActionBarProps> = ({
  children,
  className,
  visible = true,
}) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className={cn(
            "fixed bottom-0 left-0 right-0 px-4 pt-6 pb-6 sm:pb-8 bg-gradient-to-t from-background via-background/95 to-transparent z-30 pointer-events-none",
            className,
          )}
        >
          <div className="max-w-6xl w-full mx-auto pointer-events-auto flex flex-col items-center gap-2">
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
